import { cx } from '@linaria/core';
import { useActivityIndicator, Chevron } from '@utils/react';
import { chevron, throbber, chevronWrapper, toggleButton } from './toggle-button.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ToggleButton({
  showSpinner,
  isExpanded,
  as,
  theme,
  ...props
}) {
  const showThrobber = useActivityIndicator(showSpinner ?? false, {
    delayMs: 200,
    durationMs: 275
  });
  const Comp = as ?? "button";
  return /*#__PURE__*/jsxs(Comp, {
    ...props,
    // @ts-expect-error Our ref isn't typed correctly, but we use the
    // broader HTMLElement which is fine.
    ref: props.ref,
    className: cx(toggleButton, props.className),
    "data-theme": theme,
    children: [props.children, /*#__PURE__*/jsxs("div", {
      className: cx(chevronWrapper, isExpanded && "inversed"),
      children: [/*#__PURE__*/jsx(Chevron, {
        vertical: true,
        lineWidth: 2,
        size: 7,
        inversed: isExpanded,
        className: cx(chevron, showThrobber.isActive() && "hidden")
      }), /*#__PURE__*/jsx("span", {
        className: cx(throbber, !showThrobber.isActive() && "hidden")
      })]
    })]
  });
}

export { ToggleButton };
//# sourceMappingURL=toggle-button.js.map
